import { Leader } from '@peacecover/icon';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import type { components } from '@pocapan/shared/types/schema';

type ApiV1BaseLocationEvent = components['schemas']['ApiV1BaseLocationEvent'];

interface EventContentProps {
  event: ApiV1BaseLocationEvent;
}

const EventContent = ({ event }: EventContentProps) => {
  const handleEventClick = () => {
    openNewTab(`/locations/${event.locationId}/events/${event.eventId}`);
  };

  return (
    <button
      type="button"
      onClick={handleEventClick}
      className="flex items-center gap-[8px] p-[12px] rounded-[20px] border border-surface-lv2 bg-pure-white dark:bg-pure-black"
    >
      <img src={event.baseImageUrl} alt="" className="w-[60px] h-[83px] rounded-[8px]" />
      <div className="flex flex-col gap-[6px]">
        <p className="text-[15px] font-medium text-text-main-lv2 leading-[18px] text-left w-[135px] truncate">
          {event.name}
        </p>
        <div className="flex items-center gap-[4px] w-[135px] truncate">
          <Leader size={14} className="text-text-main-lv4" />
          <span className="text-[13px] font-medium text-text-main-lv4 leading-[16px]">
            {event.organizerTwitterId}
          </span>
        </div>
        {event.members && event.members.length > 0 && (
          <div className="px-[7px] py-[4px] rounded-[4px] bg-[rgba(0,0,0,0.10)] w-fit">
            <p className="text-[11px] font-semibold text-on-label leading-[13px]">
              {event.members?.map((member) => member.name).join(', ')}
            </p>
          </div>
        )}
      </div>
    </button>
  );
};
export default EventContent;
